import { render } from "./VolumeStoragePoolSelectForm.vue?vue&type=template&id=2bd20e38&scoped=true"
import script from "./VolumeStoragePoolSelectForm.vue?vue&type=script&lang=js"
export * from "./VolumeStoragePoolSelectForm.vue?vue&type=script&lang=js"

import "./VolumeStoragePoolSelectForm.vue?vue&type=style&index=0&id=2bd20e38&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd20e38"]])

export default __exports__